import { Injectable } from '@angular/core';
import { AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask } from '@angular/fire/compat/storage';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';


export interface FilesUploadMetadata {
	uploadProgress$: Observable<number>;
	downloadUrl$: Observable<string>;
}

@Injectable()
export class StorageService {


	ref!: AngularFireStorageReference;
	task!: AngularFireUploadTask;
	downloadURL: any;
	uploadProgress!: Observable<number>;


	constructor(
		private readonly storage: AngularFireStorage
	) { }

	uploadFileAndGetMetadata(
		mediaFolderPath: string,
		fileName: string,
		fileToUpload: File,
	): FilesUploadMetadata {
		// const { name } = fileToUpload;
		console.log(fileToUpload);
		const name = 'xxxx';
		const filePath = `${mediaFolderPath}/${fileName}_${name}`;
		const uploadTask: AngularFireUploadTask = this.storage.upload(
			filePath,
			fileToUpload,
		);
		return {
			uploadProgress$: uploadTask.percentageChanges() as Observable<number>,
			downloadUrl$: this.getDownloadUrl$(uploadTask, filePath),
		};
	}

	async uploadFile(image: any, path: string): Promise<AngularFireStorageReference> {
		const imageRef = this.storage.ref(path);
		await imageRef.put(image);
		return imageRef;
	}

	private getDownloadUrl$(
		uploadTask: AngularFireUploadTask,
		path: string,
	): Observable<string> {
		return from(uploadTask).pipe(
			switchMap((_) => this.storage.ref(path).getDownloadURL()),
		);
	}

}
